// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2pv6y","whiteBackground":"Layout_whiteBackground__2Yg7f"};